import { FoldableSearchBroaden } from './FoldableSearchBroaden';

type Props = {
  onSubmitSearch?: (query: { query: string }) => void;
  onValueChange?: (query: { query: string }) => void;
  onCancelSearch?: () => void;
  submitEager?: boolean;
  transparentBackground?: boolean;
  initialValue?: string;
};

export const FoldableSearchBroadenAngularWrapper = ({
  onSubmitSearch,
  onValueChange,
  ...props
}: Props) => {
  return (
    <FoldableSearchBroaden
      {...props}
      onSubmitSearch={(query: string) => onSubmitSearch?.({ query })}
      onValueChange={(query: string) => onValueChange?.({ query })}
    />
  );
};
